"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _FHIGX2EEcjs = require('../__chunks/FHIGX2EE.cjs');


var _NSONUP5Ccjs = require('../__chunks/NSONUP5C.cjs');


var _MPIQVHCBcjs = require('../__chunks/MPIQVHCB.cjs');
require('../__chunks/ITCIC2TC.cjs');
require('../__chunks/MWXEIKZX.cjs');
require('../__chunks/T3QB4FR3.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');


var _3BSDKDKDcjs = require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/form/form-push.tsx
var _misc = require('@ariakit/core/utils/misc');
var _react = require('react');
var TagName = "button";
function getFirstFieldsByName(items, name) {
  if (!items) return [];
  const fields = [];
  for (const item of items) {
    if (item.type !== "field") continue;
    if (!item.name.startsWith(name)) continue;
    const nameWithIndex = item.name.replace(/(\.\d+)\..+$/, "$1");
    const regex = new RegExp(`^${nameWithIndex}`);
    if (!fields.some((i) => regex.test(i.name))) {
      fields.push(item);
    }
  }
  return fields;
}
var useFormPush = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useFormPush2({
    store,
    value,
    name: nameProp,
    getItem: getItemProp,
    autoFocusOnClick = true,
    ...props
  }) {
    const context = _FHIGX2EEcjs.useFormContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "FormPush must be wrapped in a Form component."
    );
    const name = String(nameProp);
    const [shouldFocus, setShouldFocus] = _react.useState.call(void 0, false);
    _react.useEffect.call(void 0, () => {
      var _a;
      if (!shouldFocus) return;
      const items = getFirstFieldsByName(store == null ? void 0 : store.getState().items, name);
      const element = (_a = items == null ? void 0 : items[items.length - 1]) == null ? void 0 : _a.element;
      if (!element) return;
      element.focus();
      setShouldFocus(false);
    }, [store, shouldFocus, name]);
    const getItem = _react.useCallback.call(void 0, 
      (item) => {
        const nextItem = { ...item, type: "button", name };
        if (getItemProp) {
          return getItemProp(nextItem);
        }
        return nextItem;
      },
      [name, getItemProp]
    );
    const onClickProp = props.onClick;
    const onClick = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
      onClickProp == null ? void 0 : onClickProp(event);
      if (event.defaultPrevented) return;
      store == null ? void 0 : store.pushValue(name, value);
      if (!autoFocusOnClick) return;
      setShouldFocus(true);
    });
    props = {
      ...props,
      onClick
    };
    props = _MPIQVHCBcjs.useButton.call(void 0, props);
    props = _NSONUP5Ccjs.useCollectionItem.call(void 0, { store, ...props, getItem });
    return props;
  }
);
var FormPush = _PTOCUU2Dcjs.forwardRef.call(void 0, function FormPush2(props) {
  const htmlProps = useFormPush(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.FormPush = FormPush; exports.useFormPush = useFormPush;
